import Vue from 'vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.component('font-awesome-icon', FontAwesomeIcon);

// 'free-solid',
// 'free-regular',
// 'free-brands',
// 'pro-solid',
// 'pro-regular',
// 'pro-light',


library.add(require('@fortawesome/free-solid-svg-icons/faBell').definition);
library.add(require('@fortawesome/free-solid-svg-icons/faTimes').definition);
library.add(require('@fortawesome/pro-light-svg-icons/faTimes').definition);
library.add(require('@fortawesome/free-regular-svg-icons/faClock').definition);
library.add(require('@fortawesome/free-regular-svg-icons/faClone').definition);
library.add(require('@fortawesome/free-regular-svg-icons/faTrashAlt').definition);
library.add(require('@fortawesome/free-solid-svg-icons/faPlus').definition);
library.add(require('@fortawesome/pro-light-svg-icons/faPlus').definition);
library.add(require('@fortawesome/pro-light-svg-icons/faChevronRight').definition);
library.add(require('@fortawesome/pro-light-svg-icons/faChevronLeft').definition);
library.add(require('@fortawesome/pro-regular-svg-icons/faMapMarkerAlt').definition);
library.add(require('@fortawesome/free-solid-svg-icons/faSpinner').definition);
library.add(require('@fortawesome/free-solid-svg-icons/faEye').definition);
library.add(require('@fortawesome/free-solid-svg-icons/faEllipsisV').definition);
library.add(require('@fortawesome/free-solid-svg-icons/faTimes').definition);
library.add(require('@fortawesome/pro-light-svg-icons/faTimes').definition);
library.add(require('@fortawesome/free-solid-svg-icons/faRubleSign').definition);
library.add(require('@fortawesome/pro-light-svg-icons/faCalendarAlt').definition);
library.add(require('@fortawesome/pro-light-svg-icons/faEllipsisV').definition);


library.add(require('@fortawesome/pro-solid-svg-icons/faLongArrowRight').definition);


library.add(require('@fortawesome/pro-light-svg-icons/faAngleUp').definition);
library.add(require('@fortawesome/pro-light-svg-icons/faAngleDown').definition);
library.add(require('@fortawesome/pro-light-svg-icons/faPhone').definition);
library.add(require('@fortawesome/pro-light-svg-icons/faPencilAlt').definition);
library.add(require('@fortawesome/pro-regular-svg-icons/faPhone').definition);
library.add(require('@fortawesome/pro-regular-svg-icons/faRepeatAlt').definition);
library.add(require('@fortawesome/pro-regular-svg-icons/faPenAlt').definition);


library.add(require('@fortawesome/free-brands-svg-icons/faVk').definition);
library.add(require('@fortawesome/free-brands-svg-icons/faFacebookF').definition);
library.add(require('@fortawesome/free-brands-svg-icons/faInstagram').definition);
library.add(require('@fortawesome/free-brands-svg-icons/faYoutube').definition);
library.add(require('@fortawesome/free-regular-svg-icons/faClock').definition);
library.add(require('@fortawesome/free-regular-svg-icons/faSave').definition);

library.add(require('@fortawesome/pro-regular-svg-icons/faMapMarkerAlt').definition);
library.add(require('@fortawesome/pro-regular-svg-icons/faAngleDown').definition);
